import palette from './palette';
import { TypographyOptions } from '@material-ui/core/styles/createTypography';
import { createMuiTheme } from '@material-ui/core';
const theme = createMuiTheme();

const typography: TypographyOptions = {
  h1: {
    fontFamily: 'Poppins, Roboto, sans-serif',
    color: palette.text.primary,
    fontWeight: 700,
    fontSize: '35px',
    letterSpacing: '-0.24px',
    lineHeight: '48px',
    [theme.breakpoints.down('md')]: {
      fontSize: '28px'
    }
  },
  h2: {
    fontFamily: 'Poppins, Roboto, sans-serif',
    color: palette.text.primary,
    fontWeight: 700,
    fontSize: '29px',
    letterSpacing: '-0.24px',
    lineHeight: '40px',
    [theme.breakpoints.down('md')]: {
      fontSize: '24px'
    }
  },
  h3: {
    fontFamily: 'Poppins, Roboto, sans-serif',
    color: palette.text.primary,
    fontWeight: 700,
    fontSize: '24px',
    letterSpacing: '-0.06px',
    lineHeight: '40px',
    [theme.breakpoints.down('md')]: {
      fontSize: '20px'
    }
  },
  h4: {
    fontFamily: 'Poppins, Roboto, sans-serif',
    color: palette.text.primary,
    fontWeight: 700,
    fontSize: '20px',
    letterSpacing: '-0.06px',
    lineHeight: '30px',
    [theme.breakpoints.down('md')]: {
      fontSize: '16px'
    }
  },
  h5: {
    fontFamily: 'Poppins, Roboto, sans-serif',
    color: palette.text.primary,
    fontWeight: 700,
    fontSize: '16px',
    letterSpacing: '-0.05px',
    lineHeight: '20px',
    [theme.breakpoints.down('md')]: {
      fontSize: '14px'
    }
  },
  h6: {
    fontFamily: 'Poppins, Roboto, sans-serif',
    color: palette.text.primary,
    fontWeight: 700,
    fontSize: '14px',
    letterSpacing: '-0.05px',
    lineHeight: '20px'
  },
  subtitle1: {
    color: palette.text.primary,
    fontSize: '16px',
    letterSpacing: '-0.05px',
    lineHeight: '25px'
  },
  subtitle2: {
    color: palette.text.secondary,
    fontWeight: 400,
    fontSize: '14px',
    letterSpacing: '-0.05px',
    lineHeight: '21px'
  },
  body1: {
    fontFamily: 'Roboto, sans-serif',
    color: palette.text.primary,
    fontSize: '14px',
    letterSpacing: '-0.05px',
    lineHeight: '21px',
    [theme.breakpoints.down('md')]: {
      fontSize: '14px'
    }
  },
  body2: {
    color: palette.text.secondary,
    fontSize: '12px',
    letterSpacing: '-0.04px',
    lineHeight: '18px',
    [theme.breakpoints.down('md')]: {
      fontSize: '13px'
    }
  },
  button: {
    color: palette.text.primary,
    fontSize: '14px',
    [theme.breakpoints.down('md')]: {
      fontSize: '14px'
    }
  },
  caption: {
    color: palette.text.secondary,
    fontSize: '11px',
    letterSpacing: '0.33px',
    lineHeight: '13px'
  },
  overline: {
    color: palette.text.secondary,
    fontSize: '11px',
    fontWeight: 500,
    letterSpacing: '0.33px',
    lineHeight: '13px',
    textTransform: 'uppercase'
  }
};

export default typography;
